import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

/**
 * Fires when an office confirms the "Decline" action on the Decline offer pop-up
 * Event: dental_portal:confirm_candidate:decline_confirmed
 */
export function fireConfirmCandidateDeclineConfirmed(
  payload: IConfirmCandidatePositionContext,
): void {
  PosthogService.getInstance().track(
    'dental_portal:confirm_candidate:decline_confirmed',
    toCandidatePositionProperties(payload),
  );
}
